const firebaseConfig = {
    apiKey: "AIzaSyAgQgfXXf88f68zkyTaPLcMIU5xrRhWcWQ",
    authDomain: "hr-painting-art.firebaseapp.com",
    projectId: "hr-painting-art",
    storageBucket: "hr-painting-art.appspot.com",
    messagingSenderId: "714078572827",
    appId: "1:714078572827:web:2ad55ca67f2300420a83be"
};
export default firebaseConfig;